module.exports = __webpack_public_path__ + "img/icon_cooler_code.ca400829.png";